import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { UserInputComponent } from './components/user-input/user-input.component';
import { ChatsComponent } from './components/chats/chats.component';
import { FrontScreenComponent } from './components/screens/front-screen/front-screen.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TinaIntroComponent } from './components/screens/tina-intro/tina-intro.component';
import { MainMenuScreenComponent } from './components/screens/main-menu-screen/main-menu-screen.component';
import { AboutUsComponent } from './components/screens/about-us/about-us.component';
import { OurTeamComponent } from './components/screens/our-team/our-team.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SolutionScreenComponent } from './components/screens/solution-screen/solution-screen.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { HttpClientModule } from '@angular/common/http';
import { IntroWidgetComponent } from './components/intro-widget/intro-widget.component';
import { VideoCarouselComponent } from './components/video-carousel/video-carousel.component';
import { SafePipe } from './safe.pipe';
import { ButtonWidgetComponent } from './components/button-widget/button-widget.component';
import { SafeHTMLPipe } from './safe-html.pipe';
import { StarRatingComponent } from './components/star-rating/star-rating.component';
import { PickerModule } from "@ctrl/ngx-emoji-mart";
import { DateWidgetComponent } from './components/date-widget/date-widget.component';
import { TimeWidgetComponent } from './components/time-widget/time-widget.component';
import { DoctorsWidgetComponent } from './components/doctors-widget/doctors-widget.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { RatingFeedbackWidgetComponent } from './components/rating-feedback-widget/rating-feedback-widget.component';
import { WebcamCaptureComponent } from './components/webcam-capture/webcam-capture.component';
import {WebcamModule} from 'ngx-webcam';
import { FileuploadComponent } from './components/fileupload/fileupload.component';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { ItemCrouselWidgetComponent } from './components/item-crousel-widget/item-crousel-widget.component';
import { MessageBoxComponent } from './components/message-box/message-box.component';
import { EventCarouselWidgetComponent } from './components/event-carousel-widget/event-carousel-widget.component';
import { SponersCarouselWidgetComponent } from './components/sponers-carousel-widget/sponers-carousel-widget.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { RatingFeedbackWidgetWithMessageComponent } from './components/rating-feedback-widget-with-message/rating-feedback-widget-with-message.component';
import { DatePickerDropdownComponent } from './components/date-picker-dropdown/date-picker-dropdown.component';
import { TimePickerDropdownComponent } from './components/time-picker-dropdown/time-picker-dropdown.component';
import { DoctorCarouselComponent } from './components/doctor-carousel/doctor-carousel.component';
import { ItemDropdownComponent } from './components/item-dropdown/item-dropdown.component';
import { DatePickerWidgetComponent } from './components/date-picker-widget/date-picker-widget.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    ChatbotComponent,
    UserInputComponent,
    ChatsComponent,
    FrontScreenComponent,
    TinaIntroComponent,
    MainMenuScreenComponent,
    AboutUsComponent,
    OurTeamComponent,
    SolutionScreenComponent,
    IntroWidgetComponent,
    VideoCarouselComponent,
    SafePipe,
    ButtonWidgetComponent,
    SafeHTMLPipe,
    StarRatingComponent,
    DateWidgetComponent,
    TimeWidgetComponent,
    DoctorsWidgetComponent,
    RatingFeedbackWidgetComponent,
    WebcamCaptureComponent,
    FileuploadComponent,
    ClickOutsideDirective,
    ItemCrouselWidgetComponent,
    MessageBoxComponent,
    EventCarouselWidgetComponent,
    SponersCarouselWidgetComponent,
    RatingFeedbackWidgetWithMessageComponent,
    DatePickerDropdownComponent,
    TimePickerDropdownComponent,
    DoctorCarouselComponent,
    ItemDropdownComponent,
    DatePickerWidgetComponent,
    
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    AppRoutingModule,
    FormsModule,
    NgbModule,
    HttpClientModule,
    PickerModule,
    CarouselModule,
    WebcamModule,
    NgxIntlTelInputModule,
    ReactiveFormsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
